const j = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCAgZD0iTTEzIDUuNDE0VjIyaC0yVjUuNDE0bC02LjI5MyA2LjI5My0xLjQxNC0xLjQxNEwxMiAxLjU4Nmw4LjcwNyA4LjcwNy0xLjQxNCAxLjQxNHoiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==";
export {
  j as default
};
//# sourceMappingURL=up-ea7274ef.mjs.map
